// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"3cb7ae83","484":"b8dfb80e","630":"17844cfb","678":"a338ad17","739":"17c83270","919":"fae3c0b9"}[chunkId] + ".chunk.js";
};